<script>
const horizonalLinePlugin = {
    id: 'horizontalLine',
    afterDraw: function (chartInstance) {

        var yValue;
        var yScale = chartInstance.scales["y-axis-0"];
        var canvas = chartInstance.chart;
        var ctx = canvas.ctx;
        var index;
        var line;
        var style;
        var fontSize = (200 / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        var dataCanvaProduccion = canvas.data.datasets[0].data;
        var dataCanvaPresupuesto = canvas.data.datasets[1].data;
        var data = [];

        for (var d = 0; d < dataCanvaProduccion.length; d++) {

            var presupuestoTotal = dataCanvaProduccion[d] + dataCanvaPresupuesto[d];
            var valorPorcentaje = (((dataCanvaProduccion[d]) * 100) / presupuestoTotal)
            data.push(valorPorcentaje.toFixed(2) + "%");
        }

        for (var i = 0; i < data.length; i++) {
            var text = data[i];
            var fontSizeModel = (120 / 114).toFixed(2);
            // var textY = 480;
            ctx.font = fontSizeModel + "em sans-serif";
            ctx.fillStyle = '#FFFFFF'

            ctx.fillText(text, canvas.getDatasetMeta(0).data[i]._model.x, canvas.getDatasetMeta(0).data[i]._model.y + 15);
            ctx.fillStyle = '#080808'

            var presupuesto = dataCanvaProduccion[i] + dataCanvaPresupuesto[i];
            if (presupuesto > dataCanvaProduccion[i]) {
                ctx.fillText( Number(presupuesto).toLocaleString(undefined, {minimumFractionDigits: 2}), canvas.getDatasetMeta(1).data[i]._model.x, canvas.getDatasetMeta(1).data[i]._model.y - 10);

            } else {
                ctx.fillText( Number(presupuesto).toLocaleString(undefined, {minimumFractionDigits: 2}), canvas.getDatasetMeta(0).data[i]._model.x, canvas.getDatasetMeta(0).data[i]._model.y - 10);
            }



        }


        // ctx.save();
        if (chartInstance.options.horizontalLine) {

            for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
                line = chartInstance.options.horizontalLine[index];

                if (!line.style) {
                    style = "#080808";
                } else {
                    style = line.style;
                }

                if (line.y) {
                    yValue = yScale.getPixelForValue(line.y);
                } else {
                    yValue = 0;
                }
                ctx.lineWidth = 3;


                if (yValue) {
                    window.chart = chartInstance;
                    ctx.beginPath();
                    ctx.moveTo(0, yValue);
                    ctx.lineTo(canvas.width, yValue);
                    ctx.strokeStyle = style;
                    ctx.stroke();
                }

                if (line.text) {
                    ctx.fillStyle = style;
                    ctx.fillText(line.text, 0, yValue + ctx.lineWidth);
                }
            }
            return;
        }
    }
}



import { Bar } from 'vue-chartjs'
import { EventBus } from "@/imports/EventBus";



export default {
    props: ['dataGrafic'],
    methods: {
        async CargaInformacion() {
            console.log(this.dataGrafic)
            var valorMaximo = 0;
            for (var i = 0; i < this.dataGrafic.length; i++) {
                valorMaximo = Math.max(valorMaximo, this.dataGrafic[i].Produccion, this.dataGrafic[i].Presupuesto);
            }

            var valorEntre = valorMaximo / 10;
            var valorMax = valorMaximo + valorEntre;
            await this.addPlugin(horizonalLinePlugin);
            var labelsChart = [];
            var productionChart = [];
            var presupuestoChart = [];
            for (var s = 0; s < this.dataGrafic.length; s++) {
                var semana = this.dataGrafic[s].SemanaComercial
                labelsChart.push("S" + semana);
                productionChart.push( this.dataGrafic[s].Produccion);
                presupuestoChart.push(this.dataGrafic[s].Presupuesto - this.dataGrafic[s].Produccion);
            }

            this.renderChart({

                labels: labelsChart,
                datasets: [
                    {
                        label: 'Producción',
                        backgroundColor: '#000349',
                        data: productionChart,
                    },
                    {
                        label: 'Presupuesto',
                        backgroundColor: '#3AA9E0',
                        data: presupuestoChart,

                    }

                ]
            },
                {

                    scales: {
                        xAxes: [{
                            stacked: true,
                            categoryPercentage: 0.5,
                            barPercentage: 1,
                            scaleLabel: {
                                display: true,
                                labelString: 'Semanas Comerciales'
                            }
                        }],
                        yAxes: [{
                            stacked: true,
                            ticks: {
                                min: 6,
                                max: valorMax,
                                stepSize: valorEntre,
                                reverse: false,
                            },
                        }]
                    },
                    responsive: false,




                });
        }
    },
    extends: Bar,
    mounted() {

        EventBus.$on("ChartProduccionPorSemanaComercial", async () => {

            this.$root.$emit(
                "showLoading",
                "Cargando Ingreso por año de cumplimiento"
            );
            await this.CargaInformacion();

            this.$root.$emit("hideLoading");

        });


    }
}
</script>